import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorService } from 'services/error.service';
import { SpinnerService } from 'services/spinner.service';
import { environment } from '../../environments/environment';

@Injectable()
export class NetworkService {

    constructor(private http: Http,
                private errorService: ErrorService,
                private spinner: SpinnerService) {
    }

    get(url, params = {}) {
        let headers = this.getBaseHeaders();
        let searchParams = new URLSearchParams();

        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                searchParams.set('siteId', params[key]);
            }
        }

        return this.http.get(url, {
            search: searchParams,
            headers: headers
        }).map((res: Response) => res.json())
            .catch((error) => {
                this.spinner.hide();
                return this.errorService.handleError(error);
            });
    }

    post(url, params) {
        let headers = this.getBaseHeaders();

        return this.http.post(
            url,
            JSON.stringify(params),
            {headers}
            )
            .map(res => res.json())
            .catch((error) => {
                this.spinner.hide();
                return this.errorService.handleError(error);
            });
    }

    put(url, params) {
        let headers = this.getBaseHeaders();

        return this.http.put(
            url,
            JSON.stringify(params),
            {headers}
            )
            .map(res => res.json())
            .catch((error) => {
                this.spinner.hide();
                return this.errorService.handleError(error);
            });
    }

    delete(url) {
        let headers = this.getBaseHeaders();

        return this.http.delete(
            url,
            {headers}
            )
            .map(res => res.json())
            .catch((error) => {
                this.spinner.hide();
                return this.errorService.handleError(error);
            });
    }

    private getBaseHeaders(): Headers {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', environment.token);

        return headers;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/network.service.ts